import { IonPage, IonContent } from "@ionic/react";
import { Trophy } from "lucide-react";
import { useStore } from "../../store/useStore";
import { PageHeader } from "../../components/ui/PageHeader";
import { IconChip } from "../../components/ui/ListRow";
import { cn } from "../../lib/utils";

export default function AppSettingsPage() {
  const currentHouseholdId = useStore((s) => s.currentHouseholdId);
  const households = useStore((s) => s.households);
  const updateHouseholdSettings = useStore((s) => s.updateHouseholdSettings);

  const currentHousehold = households.find((h) => h.uuid === currentHouseholdId);
  const gamificationEnabled = currentHousehold?.gamification_enabled ?? true;

  const toggleGamification = async () => {
    if (currentHouseholdId) {
      await updateHouseholdSettings(currentHouseholdId, {
        gamification_enabled: !gamificationEnabled,
      });
    }
  };

  return (
    <IonPage>
      <PageHeader title="App Settings" backHref="/settings" />
      <IonContent>
        <div className="max-w-lg mx-auto px-4 py-4 pb-28">
          <div className="card-surface">
            <label
              htmlFor="gamification-toggle"
              className="flex items-center gap-3 px-4 py-3 min-h-[64px] cursor-pointer"
            >
              <IconChip tone="warning">
                <Trophy className="w-5 h-5" />
              </IconChip>
              <span className="flex-1 min-w-0">
                <span className="block font-semibold text-foreground">Gamification</span>
                <span className="block text-[13px] text-muted-foreground">
                  Show streaks, points, and leaderboards
                </span>
              </span>
              {/* 44px tap area around the 24px-tall switch; tests select button.h-6.w-11 */}
              <span className="inline-flex items-center justify-center min-h-[44px] min-w-[44px]">
                <button
                  id="gamification-toggle"
                  type="button"
                  role="switch"
                  aria-checked={gamificationEnabled}
                  aria-label="Gamification"
                  onClick={toggleGamification}
                  className={cn(
                    "relative inline-flex h-6 w-11 items-center rounded-full transition-colors shrink-0",
                    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
                    gamificationEnabled ? "bg-primary" : "bg-input"
                  )}
                >
                  <span
                    aria-hidden="true"
                    className={cn(
                      "inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform",
                      gamificationEnabled ? "translate-x-[22px]" : "translate-x-0.5"
                    )}
                  />
                </button>
              </span>
            </label>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
